import { Suspense, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { UsersApi } from '@/api/users/UsersApi';
import { HOME_SCREEN_ROUTE_MAP } from '@/components/HomeScreenSelector';
import { LoadingSpinner } from './LoadingSpinner';
import { Auth, HomeScreenSelector, Landing } from './lazyPages';

/**
 * Route "/" — si installé (APK/PWA) redirige vers /auth (login/dashboard),
 * sinon affiche la landing page vitrine.
 */
export function AutoRouteHome() {
  const { user, loading } = useAuth();
  const isInstalled =
    typeof window !== 'undefined' &&
    (!!window.__VISIONPOS_ANDROID || // APK
      window.matchMedia('(display-mode: standalone)').matches || // PWA installée
      window.location.hostname === 'pos.visionpos.fr'); // Domaine prod

  if (loading) return <LoadingSpinner />;
  if (user) return <Navigate to="/dashboard" replace />;
  if (isInstalled) return <Navigate to="/auth" replace />;
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Landing />
    </Suspense>
  );
}

export function AuthRedirect() {
  const { user, loading, userRole } = useAuth();
  const [homeScreen, setHomeScreen] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!user) return;
    UsersApi.getMyHomeScreen(user.id).then((res) => {
      setHomeScreen(res.ok ? res.value : null);
    });
  }, [user]);

  if (loading || (user && homeScreen === undefined)) {
    return <LoadingSpinner />;
  }

  if (user) {
    if (userRole === 'super_admin') return <Navigate to="/admin-portal" replace />;
    // Pas encore choisi d'écran d'accueil → sélecteur
    if (!homeScreen) {
      return (
        <Suspense fallback={<LoadingSpinner />}>
          <HomeScreenSelector />
        </Suspense>
      );
    }
    // Rediriger vers l'écran choisi (supporte tous les modes y compris CHR)
    return (
      <Navigate
        to={HOME_SCREEN_ROUTE_MAP[homeScreen as keyof typeof HOME_SCREEN_ROUTE_MAP] || '/caisse'}
        replace
      />
    );
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Auth />
    </Suspense>
  );
}
